module.exports = __webpack_public_path__ + "img/project_weather.877871eb.png";